/**
 * @generated SignedSource<<75c0199d40e73a32100a5f7f39b66d1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ScreenersRespondentApprovalStatusChoices = "A" | "D" | "NR" | "%future added value";
export type ScreenersRespondentMasterStatusChoices = "A" | "CS" | "D" | "IW" | "NR" | "NS" | "OQ" | "RT" | "RW" | "S" | "SS" | "T" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Cells_NextStepCell_respondent$data = {
  readonly id: string;
  readonly participant: {
    readonly id: string;
    readonly incentivized: boolean;
    readonly noShow: boolean;
    readonly rating: number;
    readonly respondent: {
      readonly approvalStatus: ScreenersRespondentApprovalStatusChoices | null;
      readonly masterStatus: ScreenersRespondentMasterStatusChoices | null;
    };
  } | null;
  readonly scheduledSlots: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"Cells_ApproveRejectedCell_respondent" | "ScheduleCell_respondent" | "ScheduledSlotCell_respondent">;
  readonly " $fragmentType": "Cells_NextStepCell_respondent";
};
export type Cells_NextStepCell_respondent$key = {
  readonly " $data"?: Cells_NextStepCell_respondent$data;
  readonly " $fragmentSpreads": FragmentRefs<"Cells_NextStepCell_respondent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Cells_NextStepCell_respondent",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipantNode",
      "kind": "LinkedField",
      "name": "participant",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rating",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noShow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incentivized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RespondentNode",
          "kind": "LinkedField",
          "name": "respondent",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "approvalStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "masterStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RespondentScheduledSlotNode",
      "kind": "LinkedField",
      "name": "scheduledSlots",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Cells_ApproveRejectedCell_respondent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleCell_respondent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduledSlotCell_respondent"
    }
  ],
  "type": "RespondentNode",
  "abstractKey": null
};
})();

(node as any).hash = "dcf58f39a0e9ea22c6f233f364f25d82";

export default node;
